import React from "react";
import PageTemplate from "../components/PageTemplate";

function Pantry() {
  return (
    <PageTemplate title="Pantry">
      <p>Your go-to blends, sauces, and basics — the kitchen essentials.</p>
    </PageTemplate>
  );
}

export default Pantry;
